/**
 * Created by Ning Jiang on 12/5/2019.
 */

import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class DeadwoodReelView extends PIXI.Container {

    private static HIGH_SYMBOLS:string[] = ["B", "S"]; // W?

    public baseContainter:PIXI.Container;
    public highContainer:PIXI.Container;
    public winContainer:PIXI.Container;
    public highWinContainer:PIXI.Container;

    constructor() {
        super();

        this.baseContainter = new PIXI.Container();
        this.highContainer = new PIXI.Container();
        this.winContainer = new PIXI.Container();
        this.highWinContainer = new PIXI.Container();
    }

    public updatePositions(x:number, y:number):void {
        this.baseContainter.position.set(x, y);
        this.highContainer.position.set(x, y);
        this.winContainer.position.set(x, y);
        this.highWinContainer.position.set(x, y);
    }

    public addChild<T extends PIXI.DisplayObject>(...children:T[]):T {
        children.forEach((child:T) => {
            if(child instanceof StateReelSymbol) {
                this.addSymbolToContainer(child);
            } else {
                super.addChild(child);
            }
        });

        return children[0];
    }

    public addSymbolToContainer(symbol:StateReelSymbol):void {
        if(DeadwoodReelView.HIGH_SYMBOLS.includes(symbol.symName)) {
            this.highContainer.addChild(symbol);
        } else {
            this.baseContainter.addChild(symbol);
        }
    }

    public addSymbolToWinContainer(symbol:StateReelSymbol):void {
        if(DeadwoodReelView.HIGH_SYMBOLS.includes(symbol.symName)) {
            this.highWinContainer.addChild(symbol);
        } else {
            this.winContainer.addChild(symbol);
        }
    }

    public removeChild<TChildren extends PIXI.DisplayObject[]>(...child:TChildren):TChildren[0] {
        if(child instanceof StateReelSymbol) {
            return this.removeSymbolFromContainer(child);
        } else {
            return super.removeChild((<PIXI.DisplayObject><any>child));
        }
    }

    public removeSymbolFromContainer(symbol:StateReelSymbol):StateReelSymbol {
        if(symbol.parent) {
            symbol.parent.removeChild(symbol);
        }

        return symbol;
    }
}